import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

/**
 * Cuenta "actual" seleccionada en el dashboard (PM multi-cuenta, F7.4). Persiste
 * la selección para que el switcher del header recuerde la cuenta entre
 * recargas. Los consumidores (e.g. AccountUsersSection) hacen fallback a la
 * cuenta primaria cuando `currentAccountId` es null.
 *
 * NO inyecta `X-Account-Id` globalmente — eso se mantiene per-llamada en el
 * adapter (ver 08-security); este store solo dirige qué cuenta mira la UI.
 */
interface AccountState {
  currentAccountId: string | null;
  setCurrentAccountId: (id: string | null) => void;
}

export const useAccountStore = create<AccountState>()(
  persist(
    set => ({
      currentAccountId: null,
      setCurrentAccountId: id => set({ currentAccountId: id }),
    }),
    {
      name: 'tankef-current-account',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
